<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="180px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="userName" label="客户名称">
              {{ formData.userName || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="pickupNumber" label="提货编号">
              {{ formData.pickupNumber || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="contractNo" label="合同编号">
              {{ formData.contractNo || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="totalAmount" label="提货总金额(元)">
              {{ formData.totalAmount || "" }}
              <span v-if="formData.goodsChange >= 0">（当前客户无欠款，余额{{ formData.goodsChange }}元）</span>
              <span v-else>（当前客户总欠款{{ Math.abs(formData.goodsChange) }}元）</span>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="releasedDepositAmount" label="释放保证金总额(元)">
              {{ formData.releasedDepositAmount || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="pickupAmount" label="释放保证金(充值)(元)">
              {{ formData.depositAmount || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="depositAmount" label="释放保证金(收益)(元)">
              {{ formData.pickupAmount || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="isDepositAmount" label="保证金抵用">
              {{ formData.isDepositAmount == '1' ? '是' : formData.isDepositAmount == '2' ? '否' : '' }}
              <span class="tips" v-if="formData.isDepositAmount == '1'">（本次订单需收款：{{ parseFloat(formData.totalAmount) -
                parseFloat(formData.depositAmount) }}）</span>
              <span class="tips" v-if="formData.isDepositAmount == '2'">（本次订单需收款：{{
                parseFloat(formData.totalAmount) }}）</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="isGoodsAmount" label="是否超额提货">
              {{ formData.isGoodsAmount === '1' ? '是' : '否' }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="pickupStatus" label="提货状态">
              <el-tag v-if="formData.pickupStatus == '1'">业务员审核</el-tag>
              <el-tag v-if="formData.pickupStatus == '2'">业务经理审核</el-tag>
              <el-tag type="success" v-if="formData.pickupStatus == '3'">已完成</el-tag>
              <el-tag type="danger" v-if="formData.pickupStatus == '4'">流程驳回</el-tag>
              <template v-if="formData.pickupStatus == '5'">
                <el-tag v-if="formData.isVehicle === '2'" type="warning">{{ isRelation ? '采购确认中' : '业务员确认中' }}</el-tag>
                <el-tag v-else type="warning">车辆装运中({{ reservationStatusMap.get(formData.reservationStatus) }})</el-tag>
              </template>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="提货单PDF">
              <a href="javascript:void(0)" v-if="formData.pickupId && formData.pdfUrl" @click="onDown(formData.pickupId)">下载</a>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime || "" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="isVehicle" label="车辆预约">
              <span v-if="formData.isVehicle === '1'">是</span>
              <span v-if="formData.isVehicle === '2'">否</span>
              <span v-if="formData.isVehicle === '3'">货转单</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleDateStart" label="可预约日期(开始)">
              {{ formData.vehicleDateStart || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleDateEnd" label="可预约日期(结束)">
              {{ formData.vehicleDateEnd || "" }}
            </el-form-item>
          </el-col>
          <!-- 仅展示当前有效预约；未预约或取消预约时不显示历史日期和时间段。 -->
          <template v-if="formData.isVehicle === '1' && formData.plannedDate && formData.reservationStatus && formData.reservationStatus !== '1'">
            <el-col :span="12">
              <el-form-item prop="plannedDate" label="已约日期">
                {{ formData.plannedDate }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="timeslotVal" label="已约时间段">
                {{ formData.timeslotVal || '--' }}
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="12">
            <el-form-item prop="vehicleKey" label="车/船号">
              {{ formData.vehicleKey }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleGph" label="挂车号">
              {{ formData.vehicleGph }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverName" label="联系人">
              {{ formData.driverName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverKey" label="身份证">
              {{ formData.driverKey }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverMobile" label="联系电话">
              {{ formData.driverMobile }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleStartAddress" label="提货库点">
              {{ formData.vehicleStartAddressName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleEndAddress" label="卸货库点">
              {{ formData.vehicleEndAddress }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col> -->
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload readonly :has-add="hasAddFile" v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="bdList" label="储运附件">
              <file-upload readonly :has-add="hasAddFile" v-model="formData.bdList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="remark" label="备注">
              {{ formData.remark || "" }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="lockedList" label="订单列表">
              <el-button type="primary" size="mini" v-if="isRelation && formData.pickupStatus === '3'"
                @click="onRelation">新增关联</el-button>
              <el-table size="mini" stripe border :data="formData.lockedList" :span-method="spanMethod">
                <el-table-column key="t-1" min-width="120" label="订单编号" prop="orderNumber"></el-table-column>
                <el-table-column key="t-2" min-width="120" label="品种规格" prop="specName"></el-table-column>
                <el-table-column key="t-3" min-width="120" label="保证金比例" prop="orderDeposit">
                  <template v-slot="{ row }">
                    {{ row.orderDeposit + "%" }}
                  </template>
                </el-table-column>
                <el-table-column key="t-4" min-width="100" label="计划数量" prop="planQuantity">
                  <template v-slot="{ row }">
                    {{ (row.planQuantity || 0) + row.specUnit }}
                  </template>
                </el-table-column>
                <el-table-column key="t-5" v-if="!isRelation" min-width="100" label="实提数量" prop="pickupQuantity">
                  <template v-slot="{ row }">
                    {{ (row.pickupQuantity || 0) + row.specUnit }}
                  </template>
                </el-table-column>
                <el-table-column key="t-6" v-if="isRelation" min-width="100" label="关联数量" prop="pickupQuantity">
                  <template v-slot="{ row }">
                    {{ (row.childPickupQuantity || 0) + row.specUnit }}
                  </template>
                </el-table-column>
                <el-table-column key="t-7" v-if="isRelation" min-width="230" label="关联单号(云采)" prop="deliveryId">
                  <template v-slot="{ row }">
                    <el-button type="text" @click="toDeliveryDetail(row.deliveryId)">{{ row.deliveryId || '--' }}</el-button>
                    <el-button v-if="row.deliveryId" type="text" @click.stop="handleCopyDeliveryId(row.deliveryId)">复制</el-button>
                  </template>
                </el-table-column>
                <template v-if="formData.orderType === '1'">
                  <el-table-column key="t-8" min-width="120" label="提货单价(元)" prop="pickupPrice"></el-table-column>
                  <el-table-column key="t-9" min-width="120" label="销售单价(元)" prop="specPrice"></el-table-column>
                  <el-table-column key="t-10" min-width="120" label="销售总价(元)" prop="specAllPrice"></el-table-column>
                  <el-table-column key="t-11" min-width="180" label="本单产生收益保证金" prop="releasedPickup"></el-table-column>
                </template>
                <template v-else>
                  <el-table-column key="t-12" min-width="120" label="暂定单价(元)" prop="pickupPrice">
                    <template v-slot="{ row }">
                      {{ (row.lockedPrice - row.priceDiff) || "" }}
                    </template>
                  </el-table-column>
                  <el-table-column key="t-13" min-width="120" label="确认单价(元)" prop="lockedPrice">
                    <template v-slot="{ row }">
                      {{ row.orderNumber.includes('-') ? row.lockedPrice : '--' }}
                    </template>
                  </el-table-column>
                  <el-table-column key="t-14" min-width="120" label="销售总价(元)" prop="specAllPrice"></el-table-column>
                </template>
                <el-table-column key="t-15" min-width="160" label="其他费用(运费等)" prop="otherFees">
                  <template v-slot="{ row }">
                    {{ row.otherFees }}<span v-if="row.remark">({{ row.remark }})</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column key="t-16" min-width="120" label="释放保证金" prop="releasedDeposit"></el-table-column> -->
                <el-table-column min-width="160" label="释放保证金(充值)" prop="releasedDepositDeposit"></el-table-column>
                <el-table-column min-width="160" label="释放保证金(收益)" prop="releasedPickupDeposit"></el-table-column>
                <!-- <el-table-column width="200" v-if="(formData.pickupStatus == 2 && hasPickupQuantity && formData.isVehicle === '2') || (formData.pickupStatus == 1 && hasApproval1) || (formData.pickupStatus == 1 && hasPlanQuantity)" -->
                <el-table-column key="t-17" width="200" v-if="!isRelation" label="操作" fixed="right">
                  <template v-slot="{ row }">
                    <el-button v-if="formData.pickupStatus == 5 && hasPickupQuantity && formData.isVehicle === '2'"
                      type="text" @click="showNumber(row)">实提数量</el-button>
                    <el-button v-if="formData.pickupStatus == 2 && hasPickupQuantity && formData.isVehicle === '3'"
                      type="text" @click="showNumber(row)">实提数量</el-button>
                    <el-button v-if="hasEditSepc && (['1', '2'].includes(formData.pickupStatus) || (formData.isVehicle === '1' && ['1', '2'].includes(formData.reservationStatus)))" type="text"
                      @click="onEditSpec(row)">修改规格</el-button>
                    <el-button v-if="formData.pickupStatus == 1 && hasApproval1" type="text"
                      @click="showOtherFees(row)">其他费用</el-button>
                    <!-- <el-button v-if="formData.pickupStatus == 1 && hasPlanQuantity" type="text"
                      @click="showPlanQuantity(row)">数量与单价</el-button> -->
                  </template>
                </el-table-column>
                <el-table-column key="t-18" width="160" v-if="isRelation" label="操作" fixed="right">
                  <template v-slot="{ row }">
                    <el-button v-if="row.deliveryId && hasEditRelation" type="text"
                      @click="editPurchaseYx">编辑关联</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formData.isVehicle === '1'">
          <el-form-item label="物流记录">
            <el-table size="mini" stripe border :data="formData.recordWlList">
              <el-table-column show-overflow-tooltip min-width="180" label="操作人" prop="operator"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作类型" prop="">
                <template v-slot="{ row }">
                  {{ operationTypeMap.get(row.operationType) || '--' }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作IP" prop="operationIp"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作终端"
                prop="operationTerminal"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作系统"
                prop="operationSystem"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="操作时间"
                prop="operationTime"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="计划入场日期"
                prop="plannedDate"></el-table-column>
              <el-table-column show-overflow-tooltip min-width="180" label="约饭" prop="">
                <template v-slot="{ row }">
                  {{ isMealFormatMap.get(row.isMeal) || '--' }}
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="" label="审批记录">
              <el-timeline :reverse="true" placement="top">
                <el-timeline-item placement="top" v-for="(item, index) of formData.recordList" :key="index"
                  :timestamp="item.approvalTime || '--'">
                  <el-card>
                    <el-row>
                      <el-col :span="24" v-if="item.approvalStatus">
                        审批状态：
                        <el-tag v-if="item.approvalStatus == '1'">待审批</el-tag>
                        <el-tag type="success" v-if="item.approvalStatus == '2'">审批通过</el-tag>
                        <el-tag type="danger" v-if="item.approvalStatus == '3'">审批驳回</el-tag>
                      </el-col>
                      <el-col :span="24">
                        审批名称：{{ item.approvalName || "--" }}
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24" v-if="item.approvalComments && item.approvalName != '修改提货订单'">
                        审批意见：{{ item.approvalComments || "--" }}
                        <el-button v-if="item.approvalComments === '修改车辆仓库信息'" type="text"
                          @click="beforeChangeRecordId = item.recordId">变动前</el-button>
                      </el-col>
                    </el-row>
                    <el-row v-if="item.approvalName != '修改提货订单'">
                      <el-col :span="12">审批人:{{ item.approver || "--" }}</el-col>
                      <el-col :span="12">审批时间：:{{ item.submitTime || "--" }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">提交人:{{ item.submitter || "--" }}</el-col>
                      <el-col :span="12">提交时间:{{ item.submitTime || "--" }}</el-col>
                    </el-row>
                    <el-row v-if="((item.fileList && item.fileList.length > 0) || hasAddFile) && item.approvalName != '修改提货订单'">
                      <el-col :span="24">
                        附件：
                        <file-upload readonly :has-add="hasAddFile" v-model="item.fileList"></file-upload>
                      </el-col>
                    </el-row>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="isRelation">
          <el-col :span="24">
            <el-button @click="$router.back()">取消</el-button>
            <el-button type="primary" v-if="hasExport" @click="exportXzFhd(pickupId)">导出发货单</el-button>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" v-if="hasBack && formData.pickupStatus == '3'"
                @click="submitBack">退回</el-button>
              <el-button type="primary" v-if="formData.pickupStatus == 1 && hasApproval1"
                @click="onAppoval">审批</el-button>
              <el-button type="primary" v-if="hasComplete && formData.pickupStatus == 5"
                @click="completeOrder">完成订单</el-button>
              <el-button type="primary" v-if="formData.pickupStatus == 2 && hasApproval2"
                @click="onAppoval">审批</el-button>
              <!-- <el-button type="primary" v-if="formData.pickupStatus == 1 && hasEdit" @click="onEdit">编辑</el-button> -->
              <template v-if="(hasEdit && formData.pickupStatus !== '3') || (hasCompleteEdit && formData.pickupStatus === '3')">
                <el-button type="primary" @click="onEdit2('edit')">编辑</el-button>
                <el-button type="primary" @click="onEdit2('modify')">修改</el-button>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
    <!-- 审批 -->
    <!-- <ApprovalDialog urlType="3" :vehicle="formData.pickupStatus == 1" :relatedId="pickupId" v-if="showDlg"
      @closeDlg="showDlg = false" @successSave="loadData" :showDlg="showDlg"></ApprovalDialog> -->
    <ApprovalDialog urlType="3" :relatedId="pickupId" v-if="showDlg" @closeDlg="showDlg = false" @successSave="loadData"
      :showDlg="showDlg"></ApprovalDialog>

    <DeliveryEditDlg :pickupId="pickupId" v-if="showEditDlg" @closeDlg="showEditDlg = false" @saveSuccess="loadData"
      :showDlg="showEditDlg"></DeliveryEditDlg>
    <DeliveryCarEditDlg :pickupId="pickupId" v-if="showCarEditDlg" @closeDlg="showCarEditDlg = false"
      @saveSuccess="loadData" :showDlg="showCarEditDlg" :mode="vehicleEditMode"></DeliveryCarEditDlg>
    <DeliveryBeforeChangeDlg v-if="beforeChangeRecordId" :pickupId="pickupId" :recordId="beforeChangeRecordId"
      @closeDlg="beforeChangeRecordId = ''"></DeliveryBeforeChangeDlg>

    <el-dialog title="提货数量" class="global-dialog" :visible.sync="showNumberVisible" width="600px">
      <div class="dlg-content">
        <el-form class="global-form" style="padding:30px 40px 20px 20px" :model="formData2" :rules="rules2" ref="form2"
          label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="pickupQuantity" label="实提数量">
                <el-input v-model="formData2.pickupQuantity" placeholder="请输入实提数量"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showNumberVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitNumber">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="其他费用" class="global-dialog" :visible.sync="showOtherFeesVisible" width="600px">
      <div class="dlg-content">
        <el-form class="global-form" style="padding:30px 40px 20px 20px" :model="formData3" :rules="rules3" ref="form3"
          label-width="120px">
          <el-row>
            <el-col :span="124">
              <el-form-item prop="otherFees" label="其他费用">
                <el-input v-model="formData3.otherFees" placeholder="请输入其他费用"></el-input>
              </el-form-item>
              <el-form-item prop="remark" label="说明">
                <el-input type="textarea" v-model="formData3.remark" placeholder="说明"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showOtherFeesVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitOtherFees">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="计划数量与销售单价" class="global-dialog" :visible.sync="showPlanQuantityVisible" width="600px">
      <div class="dlg-content">
        <el-form class="global-form" style="padding:30px 40px 20px 20px" :model="formData4" :rules="rules4" ref="form4"
          label-width="120px">
          <el-row>
            <el-col :span="124">
              <el-form-item prop="planQuantity" label="计划数量">
                <el-input v-model="formData4.planQuantity" placeholder="请输入计划数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="124">
              <el-form-item prop="specPrice" label="销售单价">
                <el-input v-model="formData4.specPrice" placeholder="请输入销售单价"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPlanQuantityVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPlanQuantity">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="关联采购提货" class="global-dialog" :visible.sync="showPurchaseYxVisible" width="800px">
      <div class="dlg-content">
        <el-form class="global-form" label-position="top" :show-message="false" inline-message
          style="padding:20px 20px 20px 20px" :model="formData5" :rules="rules5" ref="form5" label-width="120px">
          <el-button class="mb10" v-if="!isEditOrder && hasAddRelation" type="primary"
            @click="addPurchaseYx">添加采购关联</el-button>
          <el-table class="gl-list" :data="formData5.purchaseYxList" style="width: 100%">
            <el-table-column prop="orderId" label="云销点价单">
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`purchaseYxList.${$index}.orderId`"
                  :rules="[{ required: true, message: '请选择云销点价单' }]">
                  <el-select v-model="row.orderId" :disabled="isEditOrder" placeholder="请选择云销点价单"
                    @change="val => loadPurchaseData(val, row)">
                    <el-option v-for="item in formatOrderList" :key="item.orderId" :label="item.specName"
                      :value="item.orderId"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="deliveryId" label="采购提货单">
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`purchaseYxList.${$index}.deliveryId`">
                  <el-select v-model="row.deliveryId" :filterable="true" :disabled="isEditOrder"
                    placeholder="请选择关联采购提货单" @change="val => onChangePurchaseYx(val, row)">
                    <el-option v-for="item in row.purchaseList" :key="item.orderId"
                      :label="`${item.orderTitle}(${item.orderNum})`" :value="item.deliveryId"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="formatPickupQuantity" label="实提数量"></el-table-column>
            <el-table-column prop="pickupQuantity" label="采购数量">
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`purchaseYxList.${$index}.pickupQuantity`"
                  :rules="[{ required: true, message: '请输入采购数量' }]">
                  <el-input :disabled="!row.edit && isEditOrder" v-model="row.pickupQuantity"
                    placeholder="请输入采购数量"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="120" label="操作">
              <template v-slot="{ row, $index }">
                <el-button v-if="isEditOrder && !row.edit" type="text" @click="row.edit = true">修改数量</el-button>
                <el-button v-if="isEditOrder && row.edit" type="text" @click="submitPurchaseYx(row)">保存数量</el-button>
                <el-button class="del-btn" v-if="hasDelRelation" type="text"
                  @click="removePurchaseYx($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <span v-if="!isEditOrder" slot="footer" class="dialog-footer">
        <el-button @click="showPurchaseYxVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPurchaseYx">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改品种规格" class="global-dialog" :visible.sync="showSpecEditDlg" width="600px">
      <div class="dlg-content">
        <el-form class="global-form" style="padding:30px 40px 20px 20px" :model="editSpecForm" :rules="specRules"
          ref="editSpecForm" label-width="120px">
          <el-row>
            <el-col :span="124">
              <el-form-item prop="specName" label="品种规格">
                <el-input readonly v-model="editSpecForm.specName" @click.native="specVisible = true"
                  placeholder="品种规格" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="当前计划数量">
                <span>{{ currentSpecPlanQuantity }}</span>
              </el-form-item>
              <el-form-item prop="planQuantity" label="修改规格数量">
                <el-input v-model="editSpecForm.planQuantity" placeholder="请输入数量，最多三位小数" />
                <div class="tips">小于当前计划数量时，拆出填写数量为新规格，剩余数量保留原规格。</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSpecEditDlg = false">取 消</el-button>
        <el-button type="primary" :loading="specSubmitting" @click="submitEditSpec">确 定</el-button>
      </span>
    </el-dialog>

    <SpecChoose :visible.sync="specVisible" @select="onSpecSelect"></SpecChoose>

  </div>
</template>

<script>
import ApprovalDialog from '@/views/bondRecord/ApprovalDialog'
import DeliveryEditDlg from './DeliveryEditDlg'
import DeliveryCarEditDlg from './DeliveryCarEditDlg'
import DeliveryBeforeChangeDlg from './DeliveryBeforeChangeDlg'
import { validNumber3, validNumber2 } from '@/utils/validator'
import { operationType, isMealFormat, reservationStatus } from '@/utils/dict'
import { deepClone, copyText } from '@/utils/utils'
import SpecChoose from '@/components/SpecChoose.vue'

import { downloadPickupPdf } from '@/utils/pickupPdf'

export default {
  name: 'deliveryOrderDetail',
  components: { ApprovalDialog, DeliveryEditDlg, DeliveryCarEditDlg, DeliveryBeforeChangeDlg, SpecChoose },
  data() {
    return {
      specVisible: false,
      showSpecEditDlg: false,
      specSubmitting: false,
      currentSpecPlanQuantity: 0,
      operationTypeMap: operationType,
      isMealFormatMap: isMealFormat,
      reservationStatusMap: reservationStatus,
      showDlg: false,
      showEditDlg: false,
      showCarEditDlg: false,
      vehicleEditMode: 'edit',
      beforeChangeRecordId: '',
      formData: {
        orderType: '',
        pickupId: '',
        contractNo: '',
        orderNumber: '',
        userId: '',
        specId: '',
        specName: '',
        isVehicle: '',
        lockedPrice: '',
        orderQuantity: '',
        usedQuantity: '',
        parentpickupId: '',
        priceDiff: '',
        lockedDeposit: '',
        orderStatus: '',
        isDel: '',
        createUserId: '',
        ctime: '',
        fileList: [],
        bdList: [],
        recordList: [],
        recordWlList: [],
        vehicleKey: '', // 车牌号
        vehicleGph: '', //  挂车号
        driverName: '', //  司机姓名
        driverKey: '', //  司机身份证
        driverMobile: '', //  司机手机号
        vehicleStartAddress: '', //  提货库点
        vehicleEndAddress: '' //  卸货库点
      },
      formData2: {
        pickupQuantity: '',
        orderId: ''
      },
      formData3: {
        otherFees: '',
        remark: '',
        orderId: ''
      },
      rules2: {
        pickupQuantity: [
          { required: true, message: '请输入实提数量' },
          { pattern: validNumber3, message: '请输入数字可保留三位小数' }
        ]
      },
      rules3: {
        otherFees: [
          { required: true, message: '请输入其他费用' },
          { pattern: validNumber2, message: '请输入数字可保留两位小数' }
        ]
      },
      rules4: {
        planQuantity: [
          { required: true, message: '请输入计划数量' },
          { pattern: validNumber2, message: '请输入数字可保留两位小数' }
        ],
        specPrice: [
          { required: true, message: '请输入销售单价' },
          { pattern: validNumber2, message: '请输入数字可保留两位小数' }
        ]
      },
      showNumberVisible: false,
      showOtherFeesVisible: false,
      showPlanQuantityVisible: false,
      formData4: {
        planQuantity: '',
        specPrice: '',
        orderId: '',
        pickupId: ''
      },
      loading: false,
      showDetail: false,
      rowData: {},
      showPurchaseYxVisible: false,
      purchaseYxList: [],
      purchaseList: [],
      formData5: {
        purchaseYxList: []
      },
      isEditOrder: false,
      rules5: {
        purchaseYx: [
          { required: true, type: 'array', message: '请选择关联采购提货单' }
        ]
      },
      editSpecForm: {
        lockedId: null,
        orderId: '',
        specId: '',
        newSpecId: '',
        specName: '',
        planQuantity: ''
      },
      specRules: {
        planQuantity: [
          { required: true, message: '请输入修改规格数量' },
          { pattern: validNumber3, message: '请输入数字，最多保留三位小数' },
          {
            validator: (rule, value, callback) => {
              if (Number(value) <= 0) return callback(new Error('数量必须大于0'))
              if (Number(value) > Number(this.currentSpecPlanQuantity)) return callback(new Error('数量不能大于当前计划数量'))
              callback()
            }
          }
        ],
        specName: [
          { required: true, message: '请选择品种规格' }
        ]
      }
    }
  },
  async created() {
    await this.loadData()
    if (this.isRelation) {
      this.loadPurchaseYxList()
    }
  },
  computed: {
    pickupId() {
      return this.$route.query.pickupId
    },
    isRelation() {
      return this.$route.query.relation === '1'
    },
    hasExport() {
      const buttonList = this.$store.getters.getMenuByCode('CXGL')
      return buttonList.includes('export')
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    userInfo() {
      return this.$store.state.user
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasEdit2() {
      return this.buttonList.includes('caredit')
    },
    hasEditSepc() {
      return this.buttonList.includes('editspec')
    },
    hasCompleteEdit() {
      return this.buttonList.includes('completeedit')
    },
    hasComplete() {
      return this.buttonList.includes('completeorder')
    },
    hasAddFile() {
      return this.buttonList.includes('addfile')
    },
    hasPlanQuantity() {
      return this.buttonList.includes('planquantity')
    },
    hasApproval2() {
      return this.buttonList.includes('cwapproval') && this.userInfo.isLeader === '1'
    },
    hasApproval22() {
      return this.buttonList.includes('cwapproval')
    },
    // 实提数量
    hasPickupQuantity() {
      return this.buttonList.includes('pickupquantity')
    },
    hasBack() {
      return this.buttonList.includes('back')
    },
    hasApproval1() {
      return this.buttonList.includes('approval')
    },
    hasAddRelation() {
      return this.buttonList.includes('addrelation')
    },
    hasEditRelation() {
      return this.buttonList.includes('editrelation')
    },
    hasDelRelation() {
      return this.buttonList.includes('delrelation')
    },
    formatOrderList() {
      const map = new Map()
      this.formData.lockedList.forEach(item => {
        map.set(item.orderId, item)
      })
      return Array.from(map.entries()).map(item => ({
        specName: item[1].specName,
        specId: item[1].specId,
        pickupQuantity: item[1].pickupQuantity,
        orderId: item[0]
      }))
    }
  },
  methods: {
    async handleCopyDeliveryId(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    onSpecSelect(data) {
      this.editSpecForm.newSpecId = data.specId
      this.editSpecForm.specName = data.specName
    },
    submitEditSpec() {
      if (this.specSubmitting) return
      this.$refs.editSpecForm.validate().then(() => {
        if (this.specSubmitting) return
        this.specSubmitting = true
        this.$axios.post(this.$apis.deliveryOrder.updateYxPlanNewSpecId, {
          pickupId: this.pickupId,
          ...this.editSpecForm
        }).then(res => {
          this.showSpecEditDlg = false
          this.loadData()
        }).finally(() => {
          this.specSubmitting = false
        })
      })
    },
    exportXzFhd(pickupId) {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.deliveryOrder.exportXzFhd, {
        pickupId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']
          let fileName = '发货单.pdf'
          if (contentDisposition) {
            // 匹配 filename="xxx.pdf"
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1] // 拿到 ZJ202603291451445378.pdf
            }
          }
          // const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          console.log('fileName', fileName)
          this.downloadFile2(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile2(data, fileName) {
      const blob = new Blob([data], { type: 'application/pdf' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    onShowPurchaseYx() {
      this.showPurchaseYxVisible = true
    },
    // 修改为提货单状态为5，并且所有的实提数量都填了就可以完成了
    completeOrder() {
      // if (this.purchaseYxList.length === 0) {
      //   this.$message.warning('请至少关联一个云采订单')
      //   return
      // }
      this.$confirm('确认完成订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.purchaseYx.editPurchaseYx, {
          pickupId: this.pickupId
        }).then(res => {
          this.$router.back()
        })
      })
    },
    onChangePurchaseYx(val, row) {
      const purchase = row.purchaseList.find(item => item.deliveryId === val)
      if (purchase) {
        row.bidId = purchase.orderId
      }
    },
    removePurchaseYx(index) {
      const data = this.formData5.purchaseYxList[index]
      if (data.id) {
        this.$axios.post(this.$apis.purchaseYx.deleteDataPurchaseYx, {
          id: data.id
        }).then(async res => {
          this.formData5.purchaseYxList.splice(index, 1)
          await this.loadData()
          this.loadPurchaseYxList()
        })
      } else {
        this.formData5.purchaseYxList.splice(index, 1)
      }
    },
    toDeliveryDetail(deliveryId) {
      this.$router.push({
        path: '/purchaseDelivery/detail',
        query: {
          deliveryId
        }
      })
    },
    submitPurchaseYx(row) {
      let url = this.$apis.purchaseYx.insertAllPurchaseYx
      let formData = deepClone(this.formData5.purchaseYxList)
      if (this.isEditOrder) {
        url = this.$apis.purchaseYx.updatePurchaseYx
        formData = deepClone(row)
        delete formData.edit
        delete formData.purchaseList
        delete formData.formatPickupQuantity
      } else {
        formData.forEach(item => {
          delete item.edit
          delete item.purchaseList
          delete item.formatPickupQuantity
        })
      }
      this.$refs.form5.validate().then(() => {
        this.$axios.post(url, formData).then(async res => {
          await this.loadData()
          this.loadPurchaseYxList()
          this.showPurchaseYxVisible = false
        })
      })
    },
    loadPurchaseData(orderId, row) {
      console.log('rowrowrow', row)
      const specId = this.formatOrderList.find(item => item.orderId === orderId).specId
      row.formatPickupQuantity = this.formatOrderList.find(item => item.orderId === orderId).pickupQuantity
      this.$axios.get(this.$apis.purchaseDelivery.selectYcDeliveryByList, {
        deliveryState: '3',
        specId
      }).then(res => {
        // this.purchaseList = res.list || []
        row.purchaseList = res.list || []
      })
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 需要合并的列下标（根据你实际列调整）
      const mergeColumns = [0, 1, 2, 3, 6, 7, 8, 9, 10, 11, 12] // 订单号、商品名称 合并
      if (mergeColumns.includes(columnIndex) && this.isRelation) {
        console.log('rowrowrowrow', row)
        if (row.firstRow) {
          return {
            rowspan: row.rowCount,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      return {
        rowspan: 1,
        colspan: 1
      }
    },
    loadPurchaseYxList() {
      this.$axios.get(this.$apis.purchaseYx.selectPurchaseYxByList, {
        pickupId: this.pickupId
      }).then(res => {
        this.purchaseYxList = (res.list || []).map(item => {
          return {
            ...item,
            purchaseList: []
          }
        })

        // =============================================
        // 步骤1：把 list2 按 orderNumber 分组
        // =============================================
        console.log('res.list', res.list)
        const groupByOrderNum = new Map()
        res.list.forEach(item => {
          const key = item.orderNumber
          if (!groupByOrderNum.has(key)) {
            groupByOrderNum.set(key, [item])
          } else {
            groupByOrderNum.get(key).push(item)
          }
        })
        console.log('groupByOrderNum', groupByOrderNum)

        // =============================================
        // 步骤2：拼接成 table 能合并的格式
        // =============================================
        const tableData = []
        this.formData.lockedList.forEach(order => {
          const children = groupByOrderNum.get(order.orderNumber) || []
          console.log('children', children)

          if (children.length === 0) {
            tableData.push({
              ...order,
              childPickupQuantity: 0,
              // 标记第一行，用于合并
              firstRow: true,
              // 总共多少行
              rowCount: 1
            })
          } else {
            children.forEach((child, index) => {
              tableData.push({
                ...order,
                deliveryId: child.deliveryId,
                childPickupQuantity: child.pickupQuantity,
                // 标记第一行，用于合并
                firstRow: index === 0,
                // 总共多少行
                rowCount: children.length
              })
            })
          }
        })
        this.formData.lockedList = tableData
        console.log('this.formData.lockedList', this.formData.lockedList)
      })
    },
    onRelation() {
      // this.formData5.purchaseYxList = this.purchaseYxList.filter(item => item.orderId === orderId)
      // console.log('this.formData5.purchaseYxList', this.formData5.purchaseYxList)
      this.isEditOrder = false
      this.formData5.purchaseYxList = []
      this.addPurchaseYx()
      this.showPurchaseYxVisible = true
    },
    editPurchaseYx() {
      this.formData5.purchaseYxList = deepClone(this.purchaseYxList).map(item => {
        return {
          ...item,
          edit: false
        }
      })
      this.formData5.purchaseYxList.forEach(item => {
        this.loadPurchaseData(item.orderId, item)
      })
      this.isEditOrder = true
      this.showPurchaseYxVisible = true
    },
    addPurchaseYx() {
      this.formData5.purchaseYxList.push({
        deliveryId: '', // 云采提货单id
        bidId: '', // 云采点价单id
        pickupId: this.pickupId, // 云销提货单id
        orderId: '', // 云销点价单id
        pickupQuantity: '', // 关联数量
        formatPickupQuantity: '', // 格式化数量
        purchaseList: [],
        edit: false
      })
    },
    showPlanQuantity(row) {
      this.formData4.planQuantity = row.planQuantity || ''
      this.formData4.specPrice = row.specPrice || ''
      this.formData4.orderId = row.orderId
      this.formData4.pickupId = row.pickupId
      this.showPlanQuantityVisible = true
    },
    submitPlanQuantity() {
      this.$refs.form4.validate().then(() => {
        this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupNum, this.formData4).then(res => {
          this.loadData()
          this.showPlanQuantityVisible = false
        })
      })
    },
    submitBack() {
      this.$confirm('确认退回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.deliveryOrder.bakeYxPickupOrder, {
          pickupId: this.pickupId
        }).then(res => {
          this.loadData()
        })
      })
    },
    onAppoval() {
      this.showDlg = true
    },
    onDetail(row) {
      this.rowData = row
      this.showDetail = true
    },
    onDown(pickupId) {
      return downloadPickupPdf(this.$apis.deliveryOrder.downloadPickupPdf, pickupId)
    },
    onEdit() {
      this.showEditDlg = true
    },
    onEdit2(mode = 'edit') {
      this.vehicleEditMode = mode
      this.showCarEditDlg = true
    },
    onEditSpec(row) {
      this.showSpecEditDlg = true
      this.$nextTick(() => {
        this.$refs.editSpecForm.resetFields()
        this.currentSpecPlanQuantity = row.planQuantity
        this.editSpecForm = {
          lockedId: row.lockedId,
          orderId: row.orderId,
          specId: row.specId,
          newSpecId: '',
          specName: '',
          planQuantity: row.planQuantity
        }
      })
    },
    showNumber(row) {
      this.formData2.pickupQuantity = row.pickupQuantity || ''
      this.formData2.orderId = row.orderId
      this.formData2.lockedId = row.lockedId
      this.formData2.specId = row.specId
      this.showNumberVisible = true
    },
    showOtherFees(row) {
      this.formData3.otherFees = row.otherFees || ''
      this.formData3.orderId = row.orderId
      this.formData3.lockedId = row.lockedId
      this.formData3.specId = row.specId
      this.formData3.remark = ''
      this.showOtherFeesVisible = true
    },
    submitNumber() {
      this.$refs.form2.validate().then(() => {
        this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupOrder, {
          ...this.formData2,
          pickupId: this.pickupId
        }).then(res => {
          this.loadData()
          this.showNumberVisible = false
        })
      })
    },
    submitOtherFees() {
      this.$refs.form3.validate().then(() => {
        this.$axios.post(this.$apis.deliveryOrder.updateYxPlanPickupOrder, {
          ...this.formData3,
          pickupId: this.pickupId
        }).then(res => {
          this.loadData()
          this.showOtherFeesVisible = false
        })
      })
    },
    loadData() {
      this.loading = true
      return this.$axios
        .get(this.$apis.deliveryOrder.selectYxPickupOrderByPickupId, {
          params: { pickupId: this.pickupId }
        })
        .then(res => {
          res.fileList = res.fileList || []
          res.recordList = res.recordList || []
          res.lockedList = res.lockedList || []
          res.recordWlList = res.recordWlList || []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 100%;
}

.gl-list {
  .el-form-item {
    margin-bottom: 0 !important;
  }
}

.tips {
  font-size: 12px;
  color: #333;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
